// extracted by mini-css-extract-plugin
export var root = "Separator-module--root--3vwlK";
export var title = "Separator-module--title--Tz7Uj";
export var arrowTitle = "Separator-module--arrowTitle--3m602";
export var separator = "Separator-module--separator--2cB68";
export var separatorArrow = "Separator-module--separatorArrow--qIaq8";
export var separatorShort = "Separator-module--separatorShort--1C7CF";
export var marginTop = "Separator-module--marginTop--1D76p";
export var link = "Separator-module--link--1shtU";